export const authToken = () => {
  return localStorage.getItem(`token`);
};

export const setAuthToken = async (token) => {
  localStorage.setItem(`token`, token)
}
